/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

/* Ott-common */
import LiveTimeLeftCommon from '@dtvgo/live-time-left';

/* Utils */
import { useCurrentTime } from '../../providers/CurrentTimeProvider';
import useLiveContentTexts from '../../hooks/useLiveContentTexts';

function LiveTimeLeft({
  startDate,
  endDate,
  stationName = '',
  className = '',
  separator = '|',
}) {
  const { timeZone } = useIntl();
  return (
    <LiveTimeLeftCommon
      className={`dtv-html5-c-live-time-left ${className}`}
      currentTime={new Date(useCurrentTime() * 60_000)}
      startDate={startDate}
      endDate={endDate}
      formatTextTime={useLiveContentTexts()}
      stationName={stationName}
      separator={separator}
      timeZone={timeZone}
    />
  );
}

LiveTimeLeft.propTypes = {
  className: PropTypes.string,
  separator: PropTypes.string,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  stationName: PropTypes.string,
};

export default memo(LiveTimeLeft);
